export const painEntryFormConstants = Object.freeze({
  rowGutter: 50,
  painTypes: [
    "Sharp",
    "Throbbing",
    "Stabbing",
    "Cramping",
    "Shooting",
    "Dull",
    "Burning",
    "Aching",
    "Tingling",
    "Other",
  ],
  painDuration: [
    {
      label: "Less than an hour",
      value: "LESS_THAN_HOUR",
    },
    {
      label: "1-3 hours",
      value: "ONE_THREE_HOURS",
    },
    {
      label: "3-6 hours",
      value: "THREE_SIX_HOURS",
    },
    {
      label: "6-12 hours",
      value: "SIX_TWELVE_HOURS",
    },
    {
      label: "12-24 hours",
      value: "TWELVE_TWENTY_FOUR_HOURS",
    },
    {
      label: "More than 24 hours",
      value: "MORE_THAN_DAY",
    },
  ],
  reliefMethods: [
    "None",
    "Massage",
    "Rest",
    "Ice",
    "Heat",
    "Stretching",
    "Medication",
    "Acupuncture",
    "Other",
  ],
  reliefEffectiveness: [
    { value: "NONE", label: "None" },
    { value: "VERY_LITTLE", label: "Very little" },
    { value: "AVERAGE", label: "It was average" },
    { value: "WORKED_WELL", label: "It worked well" },
    { value: "WORKED_VERY_WELL", label: "It worked very well" },
  ],
  energyLevels: [
    { value: "EXHAUSTED", label: "Exhausted" },
    { value: "TIRED", label: "Tired" },
    { value: "NEUTRAL", label: "Neutral/Okay" },
    { value: "ENERGETIC", label: "Energetic" },
    { value: "VERY_ENERGETIC", label: "Very energetic" },
  ],
  symptomTrackingOptions: [
    "Fatigue",
    "Dizziness",
    "Redness",
    "Weakness",
    "Fever",
    "Nausea",
    "Swelling",
    "Stiffness",
    "Headache",
    "Other",
  ],
  symptomsDuration: [
    {
      label: "Less than an hour",
      value: "LESS_THAN_HOUR",
    },
    {
      label: "1-3 hours",
      value: "ONE_THREE_HOURS",
    },
    {
      label: "3-6 hours",
      value: "THREE_SIX_HOURS",
    },
    {
      label: "6-12 hours",
      value: "SIX_TWELVE_HOURS",
    },
    {
      label: "12-24 hours",
      value: "TWELVE_TWENTY_FOUR_HOURS",
    },
    {
      label: "More than 24 hours",
      value: "MORE_THAN_DAY",
    },
  ],
  triggerTrackingOptions: [
    "Stress",
    "Physical activity",
    "Standing",
    "Sleep quality",
    "Diet",
    "Walking",
    "Sitting",
    "Stiffness",
    "Headache",
    "Other",
  ],
  moodLevels: [
    { value: "VERY_UNHAPPY", label: "Very unhappy" },
    { value: "UNHAPPY", label: "Unhappy" },
    { value: "NEUTRAL", label: "Neutral" },
    { value: "HAPPY", label: "Happy" },
    { value: "VERY_HAPPY", label: "Very happy" },
  ],
});
export const objectifiedMoodLevels = () => {
  const obj: ObjectifiedData = {};
  for (const moodLevel of painEntryFormConstants.moodLevels) {
    obj[moodLevel.value] = moodLevel.label;
  }
  return obj;
};

export const objectifiedEnergyLevels = () => {
  const obj: ObjectifiedData = {};
  for (const moodLevel of painEntryFormConstants.energyLevels) {
    obj[moodLevel.value] = moodLevel.label;
  }
  return obj;
};
export const objectifiedDuration = () => {
  const obj: ObjectifiedData = {};
  for (const moodLevel of painEntryFormConstants.symptomsDuration) {
    obj[moodLevel.value] = moodLevel.label;
  }
  return obj;
};

export const reliefEffectivenessObjectified = () => {
  const obj: ObjectifiedData = {};
  for (const moodLevel of painEntryFormConstants.reliefEffectiveness) {
    obj[moodLevel.value] = moodLevel.label;
  }
  return obj;
};
export const bodyPainColorsByRating = () => {
  const obj: any = {
    1: "#00FF00",
    2: "#66FF66",
    3: "#CCFF66",
    4: "#FFFF00",
    5: "#FFCC66",
    6: "#FF9933",
    7: "#FF6600",
    8: "#FF3300",
    9: "#FF0000",
    10: "#CC0000",
  };
  return obj;
};
